import { render } from "./PromotionComponent.vue?vue&type=template&id=d6226890"
import script from "./PromotionComponent.vue?vue&type=script&lang=js"
export * from "./PromotionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/home/PromotionComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d6226890"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d6226890', __exports__)) {
    api.reload('d6226890', __exports__)
  }
  
  module.hot.accept("./PromotionComponent.vue?vue&type=template&id=d6226890", () => {
    api.rerender('d6226890', render)
  })

}


export default __exports__